import * as React from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import Tooltip from '@/ui-kit/components/Tooltip/Tooltip';
import { Card } from '../../Card/Card';
import { ProductLookup } from '@/ui-kit/domain/lookup/ProductLookup';
import {
  IUICfgComponentElementOptions,
  IUICfgProduct,
  IUICfgProductsElementOptions,
} from '@canvas-logic/clp-api-types';

interface IProps {
  lookup: ProductLookup;
  viewElement: IUICfgProduct;
  componentSettings: IUICfgComponentElementOptions;
}

const ProductCfgUIElement: React.FC<IProps> = (props) => {
  const { lookup, viewElement } = props;
  const uiSettings = viewElement.uiControl as IUICfgProductsElementOptions;

  const productDatas = lookup.productData;

  const cardOrientation = uiSettings.layout === 'card' ? 'vertical' : 'horizontal';
  if (!lookup.isEnable()) {
    return null;
  }

  const showTitle = uiSettings.showTitle;
  const showImage = uiSettings.showImage; // TODO: implement;
  const showDescription = uiSettings.showDescription;
  if (!lookup.initialized) {
    return null;
  }

  const canBeDisable = lookup.canBeDisable;
  const isLocked = !canBeDisable && productDatas.length === 1;

  return (
    <>
      {productDatas.map((productData) => {
        const selected = String(productData.productId) === lookup.current?.value.value;

        const hasTooltip = showDescription && !!productData.texts.description;

        return (
          <div className={classNames('cp-product')} data-product-id={productData.productId} key={productData.productId}>
            <Tooltip disabled={!hasTooltip} title={''} description={productData.texts.description}>
              {(onOpen) => (
                <Card
                  key={lookup.id}
                  orientation={cardOrientation}
                  imageSrc={showImage ? productData.images[0]?.url : undefined}
                  label={showTitle ? productData.texts.name : undefined}
                  description={productData.texts.shortDescription ?? ''}
                  value={productData.productId}
                  selected={selected}
                  disabled={isLocked}
                  hasAlwaysOn={isLocked}
                  onSelect={(value) => {
                    if (selected) {
                      if (!props.componentSettings.showSwitcher) {
                        lookup.unselect();
                      }
                    } else {
                      lookup.select({ value: String(value) });
                    }
                  }}
                  onTooltipClick={onOpen}
                  hasTooltip={hasTooltip}
                />
              )}
            </Tooltip>
          </div>
        );
      })}
    </>
  );
};

export default observer(ProductCfgUIElement);
